import * as React from 'react';
import { MultiTaggedTile } from '@mitchell/react.component.ux';
import { StyledTileListWrapper } from './AlbumGroup.style';
import { DOWNLOAD_ARTIFACT } from '../constants';
export const AlbumGroup = (props) => {
    const renderTiles = () => {
        return props.tiles.map((tile, index) => {
            const warningTypeIcon = tile.isSelected ? undefined : tile.warningTypeIcon;
            return (React.createElement(MultiTaggedTile, Object.assign({ key: `${props.id}-${tile.id}-${index}` }, tile, { warningTypeIcon: warningTypeIcon }, props, { id: tile.id })));
        });
    };
    return props.tiles.length > 0 ? (React.createElement(StyledTileListWrapper, { container: true, id: `${DOWNLOAD_ARTIFACT.ID_ALBUM_GROUP_TILE_LIST_WRAPPER}_${props.id}`, "data-testid": `${DOWNLOAD_ARTIFACT.ID_ALBUM_GROUP_TILE_LIST_WRAPPER}_${props.id}`, tilesGap: props.tilesGap, style: props.panelBackgroundColor ? { backgroundColor: props.panelBackgroundColor } : undefined, isSelectModeOn: props.isSelectModeOn }, renderTiles())) : null;
};
//# sourceMappingURL=AlbumGroup.js.map